/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="88.87"
        height="95.59"
        viewBox="0 0 88.87 95.59"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M5.91 35.77a1.25 1.25 0 0 1 .88 2.34 6.58 6.58 0 0 0 2.88 12.71 1.254 1.254 0 0 1 .3 2.49h-.1a9.08 9.08 0 0 1-4-17.54Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M69.73 46.64a2.29 2.29 0 1 1-2.3-2.27 2.28 2.28 0 0 1 2.29 2.28"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M72.25 23.04a1.25 1.25 0 0 1 1.22 1.25 1 1 0 0 1-.08.43l-.28.77-.26.74-.25.75-.12.36-.21.7c-.11.35-.21.7-.3 1l-.17.67c-.11.43-.2.84-.29 1.25l-.11.6c-.49 2.77-.33 4.82.6 5.82l.9.92 2.91 2.91.61.62.65.69.41.43.46.51.1.13c1.33 1.58 5.06 2.55 9.66 2.89a1.23 1.23 0 0 1 1.15 1.12v.13l-.1 11.83a1.2 1.2 0 0 1-.29.79l-.1.11-13 12.41-.12.12c-.32.42-.64.82-1 1.21a2 2 0 0 0-.12.19v.1l-7.84 20.25a1.23 1.23 0 0 1-1 .81h-6.81a1.25 1.25 0 0 1-1.22-1v-.13l-1.12-8.23a.68.68 0 0 0-.32-.5.72.72 0 0 0-.59-.08 37.9 37.9 0 0 1-22.22 0 .77.77 0 0 0-.59.08.85.85 0 0 0-.3.4v.1l-1.1 8.3a1.24 1.24 0 0 1-1.12 1.09h-6.72a1.22 1.22 0 0 1-1.14-.74v-.12l-6.34-19.81a.71.71 0 0 0-.11-.21l-.08-.1-.31-.36a26.76 26.76 0 0 1-6.36-16.83v-.5a26.81 26.81 0 0 1 11.82-22.27 1.26 1.26 0 0 1 1.4 2.09 24.3 24.3 0 0 0-6.58 33.73c.5.74 1 1.45 1.61 2.14l.32.37a3 3 0 0 1 .55.89l.09.21 6.09 19h4.65l.9-7.1a3.24 3.24 0 0 1 1.29-2.16l.16-.11a3.25 3.25 0 0 1 2.68-.38 35.41 35.41 0 0 0 20.74 0 3.22 3.22 0 0 1 4 2.12c0 .11.06.22.08.33v.19l1 7.14h4.67l7.53-19.45a3.68 3.68 0 0 1 .44-.8l.14-.19c.3-.35.59-.73.87-1.1l.25-.3.15-.15 12.63-12 .09-10.15h-.17c-4.51-.45-8.06-1.48-9.88-3.45l-.17-.2-.19-.22-.21-.24-.37-.4-.6-.63-1-1-3-3-.65-.66c-2.21-2.38-2-6.75-.11-12.49l.26-.79v-.12c-2.7.6-5.36 2.51-7.76 5.17l-.27.31a3.54 3.54 0 0 1-3.92 1 37.68 37.68 0 0 0-4.56-1.43 1.25 1.25 0 1 1 .59-2.43 42.78 42.78 0 0 1 4.86 1.52 1 1 0 0 0 1.14-.28c3.49-3.98 7.5-6.62 11.86-6.58Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M35.65 0a21.44 21.44 0 1 0 21.4 21.48A21.45 21.45 0 0 0 35.65 0Zm0 2.5a18.95 18.95 0 1 1-18.94 19 18.94 18.94 0 0 1 18.94-19Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M34.47 8.34v2.21l-.34.06-.35.07a5.29 5.29 0 0 0-4 3.23 6.55 6.55 0 0 0-.46 3 5.18 5.18 0 0 0 2.75 4.41 23.34 23.34 0 0 0 2.31 1c1 .41 2 .78 2.92 1.19a1.77 1.77 0 0 1 1.14 2 1.89 1.89 0 0 1-1.54 1.92 5 5 0 0 1-1.23.08 3 3 0 0 1-3.11-2.27c-.09-.27-.15-.55-.23-.85l-3.7 1a7.74 7.74 0 0 0 1.79 3.65 6.23 6.23 0 0 0 4.05 1.91v2.85h2.39v-2.83c.48-.09.94-.17 1.4-.29a5.47 5.47 0 0 0 3.89-3.13 6.29 6.29 0 0 0 .44-3.85 5 5 0 0 0-2.58-3.66 25.26 25.26 0 0 0-3.54-1.54c-.72-.3-1.43-.64-2.13-1a1.59 1.59 0 0 1-.79-1 2.17 2.17 0 0 1 1.5-2.67 2.49 2.49 0 0 1 2.47.66 4.57 4.57 0 0 1 1 1.52c.08.18.15.36.23.56l3.3-1.37a6.42 6.42 0 0 0-1.21-2.49 5.75 5.75 0 0 0-4-2.09V8.41Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'PiggybankWithCoinIcon';

export default Icon;
